import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=7cbace6d&scoped=true&"
import script from "./InfoButton.vue?vue&type=script&lang=ts&"
export * from "./InfoButton.vue?vue&type=script&lang=ts&"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=7cbace6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbace6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
